import React from "react";
import ReactDOM from "react-dom";
import { PortfolioLandingPage } from "./PortfolioLandingPage";
import { QueryClient, QueryClientProvider } from "react-query";
import { UserProvider } from "UserContext";

let portfolioPageContainer = document.getElementById(
  "portfolio-landing-page-container"
);
let portfolioId = portfolioPageContainer.getAttribute("data-portfolio-id");
// let portfolio = JSON.parse(
//   portfolioPageContainer.getAttribute("data-portfolio")
// );
let userId = portfolioPageContainer.getAttribute("data-user-id");
let portfolioTagId = portfolioPageContainer.getAttribute("data-portfolio-tag-id");
let companyIds = portfolioPageContainer.getAttribute("data-company-ids");
if (companyIds && companyIds.length) {
  companyIds = companyIds.split(",");
}

//const portfolioTagId = portfolioPageContainer.getAttribute("data-portfolio-tag-id");

const queryClient = new QueryClient();

ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <UserProvider userId={userId}>
      <PortfolioLandingPage
        portfolioId={portfolioId}
        portfolioTagId={portfolioTagId}
        baselineCompanyIds={companyIds}
        userId={userId}
      />
    </UserProvider>
  </QueryClientProvider>,
  portfolioPageContainer
);
